import { UserDataAction, CommonAction } from 'Actions/index';
import { UserDataActionTypes, CommonActionTypes } from 'Actions/ActionTypes/index';
import { IUserData } from 'Store/IUserData';
import { UserData } from 'NSwag/ServerClient/Client.nswag';

let initialState: IUserData = new UserData();

export const userData = (state: IUserData = initialState, action: UserDataAction | CommonAction) => {

    let newState: UserData;

    switch (action.type) {
        case UserDataActionTypes.SetUserData:
            newState = action.userData;
            break;
        case CommonActionTypes.ClearStore:
            newState = initialState;
            break;
        default:
            newState = state;
    }

    return newState;
}